import { Routes, RouterModule } from '@angular/router';
import { HomeComponent, EditComponent, ListComponent } from './pages';
import { MainLayoutComponent } from './layout/mainlayout/mainlayout.component';

const appRoutes: Routes = [
     // App routes goes here here
     { 
        path: 'editor',
        component: MainLayoutComponent, 
        children: [
            { path: 'edit', component: EditComponent }
        ]
    },
    //no layout routes

    // otherwise redirect to home
    { path: '**', redirectTo: 'home' },
    { path: '', component: HomeComponent },
    { path: 'list', component: ListComponent },
    { path: 'listplay', component: ListComponent }
];

export const routing = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/app/app.routing.ts